module.exports = __webpack_public_path__ + "img/YYB_DownLoad.538580f8.png";